import { AlertCircle, Check, X } from "react-feather";
import Button from "./Button";
import React, { useImperativeHandle, forwardRef, useRef } from "react";
import Modal from "../Modal";

const CustomAlert = forwardRef(
  ({ message = "Are you sure?", onAccept, onClose = () => {} }, ref) => {
    useImperativeHandle(ref, () => ({
      openAlert: () => {
        modalRef.current?.showModal();
      },
    }));
    const modalRef = useRef(null);
    return (
      <Modal ref={modalRef} minWidth={"300px"} clickOutSide={false}>
        <div style={{ padding: "10px" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <AlertCircle color="red" size="25" />
              <p>Warning</p>{" "}
            </h3>
            <h3 style={{ whiteSpace: "pre-line" }}>{message}</h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "5px",
                paddingBottom: "5px",
                gap: "5px",
              }}
            >
              <Button
                Icon={X}
                label={"Cancel"}
                onClick={() => {
                  onClose && onClose();
                  modalRef.current?.close();
                }}
                color="red"
              />
              <Button
                Icon={Check}
                label={"Proceed"}
                onClick={() => {
                  onAccept && onAccept();
                  modalRef.current?.close();
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  },
);

export default CustomAlert;
